import '@banno/jha-wc/src/icons/jha-icon-arrow-forward';
import { DeepReactive } from '@jack-henry/frontend-utils/lit';
import { DayOfWeek } from '@treasury/domain/backoffice/services/access/entities/time-access.entity';
import { UserTimeAccessDay } from '@treasury/domain/company/user';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/jh-ui/tm-button';
import '@treasury/presentation/components/jh-ui/tm-checkbox';
import '@treasury/presentation/components/jh-ui/tm-input';
import '@treasury/presentation/components/jha-wc/tm-select';
import '@treasury/presentation/components/tm-time-picker';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './time-access-day.component';

@customElement('tm-bo-time-access')
export class TimeAccessComponent extends TmBaseComponent {
    @property({ type: Boolean })
    public restricted: boolean = false;

    @DeepReactive()
    public timeAccessDays: UserTimeAccessDay[] = [];

    public render() {
        return html`
            <div>
                <h1 class="text-2xl font-bold mb-6">Time Access</h1>
                <p class="mb-4">
                    Set the times during which the user will have access to log in to the system.
                </p>
                ${this.renderRestrictedToggle()}
                ${this.restricted
                    ? this.timeAccessDays
                          .sort((a, b) => {
                              const shiftA = a.dayOfWeek === 0 ? 7 : a.dayOfWeek;
                              const shiftB = b.dayOfWeek === 0 ? 7 : b.dayOfWeek;
                              return shiftA - shiftB;
                          })
                          .map(day => this.renderDayAndTimeAccess(day))
                    : nothing}
            </div>
        `;
    }

    private renderRestrictedToggle() {
        return html`<tm-jh-switch
            class="mb-2"
            .initial=${this.restricted}
            .label=${'Restricted'}
            .name=${'timeAccess.restricted'}
            @change=${this.handleRestrictedToggle}
        >
        </tm-jh-switch>`;
    }

    private renderDayAndTimeAccess(day: UserTimeAccessDay) {
        return html`<tm-bo-time-access-day
            .day=${day}
            .restricted=${this.restricted}
            @apply-to-all-week-days=${this.handleApplyToAllWeekDays}
        >
        </tm-bo-time-access-day>`;
    }

    private handleApplyToAllWeekDays(e: CustomEvent<{ day: UserTimeAccessDay }>) {
        const { day } = e.detail;

        if (!this.timeAccessDays) {
            return;
        }
        const weekendDays = [DayOfWeek.Saturday, DayOfWeek.Sunday];
        this.timeAccessDays
            .filter(d => !weekendDays.includes(d.dayOfWeek))
            .forEach(d => {
                d.timeAccessType = day.timeAccessType;
                d.beginTime = day.beginTime;
                d.endTime = day.endTime;
            });
    }

    private handleRestrictedToggle(e: CustomEvent<boolean>) {
        if (!this.timeAccessDays) {
            return;
        }
        this.restricted = e.detail;
    }
}
